'use client';

import { createContext } from 'react';

/**
 * Само самият контекст — нарочно отделен от `ToastContext.js`.
 *
 * ПРИЧИНАТА: `ToastContext.js` съдържа и `ToastProvider`, който тегли
 * `ToastMessage → Toast`. Webpack включва модули цели, затова всеки компонент, поискал
 * контекста през `useToastMessage`, влачеше и провайдъра с всичките му зависимости. На
 * началната страница това означаваше, че сърцето върху всяка корица
 * (`CoverFavoriteHeart`) издърпва отделен chunk от 283 KB икони, който после не ползва.
 *
 * Ако тук се добави каквото и да е освен `createContext`, веригата се възстановява.
 */
export const ToastContext = createContext();
